import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "df775941-1b76-4a8b-929f-b43c1b32ef2c",
  publicId: "26",
  name: "Loudspeaker  nonlinearities",
  difficulty: 3,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, task01],
};

export default lesson;
